import { Typography } from '@material-ui/core'
import React from 'react'

import { Activity, ParticipantType, ServiceType } from '../../../services/Model/Activity'
import { ParticipantOutcome } from '../../../services/Model/Outcome'
import CareerExplorationOtherEnrolled from '../CareerExplorationOtherEnrolled/CareerExplorationOtherEnrolled'
import GeneralEducationOtherEnrolled from '../GeneralEducationOtherEnrolled/GeneralEducationOtherEnrolled'
// tslint:disable-next-line:max-line-length
import InternshipsWBLOtherEnrolled from '../InternshipsWorkbasedLearningOtherEnrolled/InternshipsWorkbasedLearningOtherEnrolled'
// tslint:disable-next-line:max-line-length
import JobSearchPlacementJobSeekersNewHires from '../JobSearchPlacementJobSeekersNewHires/JobSearchPlacementJobSeekersNewHires'
import WorkforceTrainingBusinessOwners from '../WorkforceTrainingBusinessOwners/WorkforceTrainingBusinessOwners'
import WorkforceTrainingIncumbentWorkers from '../WorkforceTrainingIncumbentWorkers/WorkforceTrainingIncumbentWorkers'
// tslint:disable-next-line:max-line-length
import WorkforceTrainingJobSeekersNewHires from '../WorkforceTrainingJobSeekersNewHires/WorkforceTrainingJobSeekersNewHires'
import WorkforceTrainingOtherEnrolled from '../WorkforceTrainingOtherEnrolled/WorkforceTrainingOtherEnrolled'

const ParticipantOutcomeFormPicker = (
	participantOutcomes: ParticipantOutcome,
	onFormSubmit: (outcomes: ParticipantOutcome) => void,
  employers: any[],
  onLocalOutcomesUpdate,
  outcomesCopy: ParticipantOutcome,
	activity?: Activity
) => {
	const { participantType, serviceType } = activity || {}

	switch (true) {
		case serviceType === ServiceType.WORKFORCE_TRAINING && participantType === ParticipantType.JOBSEEKERS_NEW_HIRES: {
			return <WorkforceTrainingJobSeekersNewHires outcomes={participantOutcomes} onSubmit={onFormSubmit} employers={employers} onLocalOutcomesUpdate={onLocalOutcomesUpdate}  outcomesCopy={outcomesCopy}/>
		}

		case serviceType === ServiceType.WORKFORCE_TRAINING && participantType === ParticipantType.INCUMBENT_WORKERS: {
			return <WorkforceTrainingIncumbentWorkers outcomes={participantOutcomes} onSubmit={onFormSubmit} employers={employers} onLocalOutcomesUpdate={onLocalOutcomesUpdate} outcomesCopy={outcomesCopy}/>
		}

		case serviceType === ServiceType.WORKFORCE_TRAINING && participantType === ParticipantType.OTHER_ENROLLED: {
			return <WorkforceTrainingOtherEnrolled outcomes={participantOutcomes} onSubmit={onFormSubmit} employers={employers} onLocalOutcomesUpdate={onLocalOutcomesUpdate} outcomesCopy={outcomesCopy}/>
		}

		case serviceType === ServiceType.GENERAL_EDUCATION && participantType === ParticipantType.OTHER_ENROLLED: {
			return <GeneralEducationOtherEnrolled outcomes={participantOutcomes} onSubmit={onFormSubmit} employers={employers} onLocalOutcomesUpdate={onLocalOutcomesUpdate} outcomesCopy={outcomesCopy}/>
		}

		case serviceType === ServiceType.JOB_SEARCH_PLACEMENT_ASSISTANCE &&
			participantType === ParticipantType.JOBSEEKERS_NEW_HIRES: {
			return <JobSearchPlacementJobSeekersNewHires outcomes={participantOutcomes} onSubmit={onFormSubmit} employers={employers} onLocalOutcomesUpdate={onLocalOutcomesUpdate} outcomesCopy={outcomesCopy}/>
		}

		case serviceType === ServiceType.INTERNSHIPS_WORK_BASED_LEARNING &&
			participantType === ParticipantType.OTHER_ENROLLED: {
			return <InternshipsWBLOtherEnrolled outcomes={participantOutcomes} onSubmit={onFormSubmit} employers={employers} onLocalOutcomesUpdate={onLocalOutcomesUpdate} outcomesCopy={outcomesCopy}/>
		}

		case serviceType === ServiceType.WORKFORCE_TRAINING &&
			participantType === ParticipantType.BUSINESS_OWNERS_ENTREPRENEURS: {
			return <WorkforceTrainingBusinessOwners outcomes={participantOutcomes} onSubmit={onFormSubmit} onLocalOutcomesUpdate={onLocalOutcomesUpdate}  outcomesCopy={outcomesCopy}/>
		}

		case serviceType === ServiceType.CAREER_EXPLORATION_ESSENTIAL_SKILLS &&
			participantType === ParticipantType.OTHER_ENROLLED: {
			return <CareerExplorationOtherEnrolled outcomes={participantOutcomes} onSubmit={onFormSubmit} serviceType={serviceType} employers={employers} onLocalOutcomesUpdate={onLocalOutcomesUpdate} outcomesCopy={outcomesCopy}/>
		}

		default: {
			return (
				<Typography color="secondary" variant="h6" align="center">
					Form Not Available
				</Typography>
			)
		}
	}
}

export default ParticipantOutcomeFormPicker
